<template>
    <AuthenticatedLayout
        :title="__(page.title)"
        :footerContainer="false"
    >
    <div class="max-w-screen-xl mx-auto">

        <div class="grid lg:grid-cols-3 gap-3">
            <div class="bg-white shadow-md rounded-md md:p-6 p-3 lg:col-span-2 flex flex-col">
                <Heading
                    :label="__(page.title)"
                    class="justify-center text-center mb-5"
                    type="h1"
                />
                <div class="ql-snow">
                    <div v-html="page.options.content" class="ql-editor content"></div>
                </div>
                <Heading
                    :label="__(page.options.subtitle ? page.options.subtitle : 'Title')"
                    class="mt-10 justify-center"
                />
                <div
                    class="grid grid-cols-2 gap-3 text-gray-200"
                    :class="{
                        'lg:grid-cols-4': page.options.icons.length <= 4,
                        'xl:grid-cols-5 lg:grid-cols-4': page.options.icons.length >= 5
                    }"
                >
                    <a
                        v-for="item in page.options.icons"
                        :key="item.id"
                        :href="item.url ? item.url : ''"
                        :class="[
                            item.url ? 'hover:border-gray-200 transition duration-300' : ''
                        ]"
                        target="_blank"
                        class="m-auto overflow-hidden border-2 border-gray-900 rounded-full shadow-md w-full flex flex-col items-center justify-center"
                    >
                        <img :src="item.link" class="max-w-full max-h-full p-2 h-16 object-contain"/>
                    </a>
                </div>
            </div>

            <div
                class="bg-gray-900 text-gray-200 shadow-md rounded-md md:p-6 p-3 lg:h-full h-64 lg:w-full sm:w-3/4 w-full mx-auto"
                :style="'background: linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 0.1)),url(' + (page.options.image ? page.options.image : '/img/cms/logo-color.png') + '); background-size: cover; background-position:center;'"
            >
            </div>

            <div class="bg-white shadow-md rounded-md md:p-6 p-3 lg:col-span-full mt-5 ql-snow">
                <div v-html="page.content" class="-mx-4 ql-editor content"></div>
            </div>
        </div>

    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import InputLabel from 'UI/InputLabel';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        InputLabel,
    },
    props: {
        auth: Object,
        loggedin: Boolean,
        page: [Object, Array],
    },
    setup(props) {

        return {

        }
    },

}
</script>
